export function formatNumbers(value, maximumFractionDigits = 2)
{
  if (value != undefined)
  {
    return value.toLocaleString('en-US', {maximumFractionDigits: maximumFractionDigits});
  }

  return value;
}

export function roundValue (value, precision)
{
  if (value !== undefined)
  {
    let factor = Math.pow(10, precision);
    return Math.round(value * factor) / factor;
  }

  return value;
}

export function dateFormatDefault () {
    return 'D MMM YYYY, ddd';
}


// WEBPACK FOOTER //
// ./src/helpers/format.js